// @flow

import { UPDATE_TASK_INSTANCE_SUCCESS, UPDATE_SUBTASK_STATUS } from '../shiftTasks/actions';
import type {
  LogInResponse,
  Shift,
  SetTimeClockDataAction,
  GetTimeClockStateAction,
  ClearTimeClockDataAction,
  UpdateShiftListAction,
  UpdateShiftAction,
  StartAdHocClockInAction,
  GetTimeClockStateFinishedAction,
  UpdateTaskInstanceSuccessAction,
  UpdateSubtaskStatusAction,
  AddOrEditTimeclockNoteSuccessAction,
  SetHideGreetingAction
} from '../common/typings';

import {
  SET_TIME_CLOCK_DATA,
  CLEAR_TIME_CLOCK_DATA,
  UPDATE_SHIFT_LIST,
  UPDATE_SHIFT,
  GET_TIME_CLOCK_STATE,
  START_AD_HOC_CLOCK_IN,
  GET_TIME_CLOCK_STATE_FINISHED,
  ADD_OR_EDIT_TIMECLOCK_NOTE_SUCCESS,
  SET_HIDE_GREETING
} from './actions';

export type State = {|
  +data: LogInResponse | null,
  +loadingUserShifts: boolean,
  +shifts: Array<Shift>,
  +shift: Shift | null,
  +adHocShift: Shift | null,
  +hideGreeting: boolean
|};

type Action =
  | SetTimeClockDataAction
  | GetTimeClockStateAction
  | ClearTimeClockDataAction
  | UpdateShiftListAction
  | UpdateShiftAction
  | StartAdHocClockInAction
  | GetTimeClockStateFinishedAction
  | UpdateTaskInstanceSuccessAction
  | UpdateSubtaskStatusAction
  | AddOrEditTimeclockNoteSuccessAction
  | SetHideGreetingAction;

export const initialState = {
  data: null,
  loadingUserShifts: false,
  shifts: [],
  shift: null,
  adHocShift: null,
  hideGreeting: false
};

export default function timeClock(state: State = initialState, action: Action) {
  switch (action.type) {
    case SET_TIME_CLOCK_DATA:
      return {
        ...state,
        data: action.payload.data
      };
    case GET_TIME_CLOCK_STATE:
      return {
        ...state,
        loadingUserShifts: true
      };
    case CLEAR_TIME_CLOCK_DATA:
      return {
        ...state,
        data: null,
        shifts: [],
        shift: null,
        adHocShift: null,
        loadingUserShifts: false
      };
    case UPDATE_SHIFT_LIST: {
      return {
        ...state,
        shifts: action.payload.shifts,
        loadingUserShifts: false
      };
    }
    case UPDATE_SHIFT:
      return {
        ...state,
        shift: action.payload.shift,
        loadingUserShifts: false
      };
    case ADD_OR_EDIT_TIMECLOCK_NOTE_SUCCESS:
      return {
        ...state,
        shift: {
          ...state.shift,
          assigneeNotes: action.payload.note
        }
      };
    case START_AD_HOC_CLOCK_IN:
      return {
        ...state,
        loadingUserShifts: false,
        adHocShift: action.payload.shift
      };
    case GET_TIME_CLOCK_STATE_FINISHED:
      return {
        ...state,
        loadingUserShifts: false
      };
    case UPDATE_TASK_INSTANCE_SUCCESS: {
      const { taskInstance } = action.payload;
      const { shift } = state;

      if (!shift || !shift.taskInstances) {
        return state;
      }

      return {
        ...state,
        shift: {
          ...shift,
          taskInstances: (shift.taskInstances: any).map(instance => {
            if (taskInstance.id === instance.id) {
              return taskInstance;
            }
            return instance;
          })
        }
      };
    }
    case UPDATE_SUBTASK_STATUS: {
      const { taskInstance, subtaskId, status } = action.payload;
      const { shift } = state;

      if (!shift || !shift.taskInstances) {
        return state;
      }

      return {
        ...state,
        shift: {
          ...shift,
          taskInstances: (shift.taskInstances: any).map(instance => {
            if (taskInstance.id === instance.id) {
              return {
                ...taskInstance,
                subtasks: taskInstance.subtasks?.map(subtask => {
                  if (subtask.id === subtaskId) {
                    return { ...subtask, status };
                  }
                  return subtask;
                })
              };
            }
            return instance;
          })
        }
      };
    }
    case SET_HIDE_GREETING: {
      return {
        ...state,
        hideGreeting: action.payload.isGreetingVisible
      };
    }

    default:
      // (action: empty); is a way to enforce exhaustiveness in flow.
      // That means every action provided in Action type have to be handled in reducer.
      (action: empty); // eslint-disable-line
      return state;
  }
}
